import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { useDashMessages } from 'intl/intl.hooks'
import { PlacementPlatformEnum } from 'domains/banners/api'

interface Props {
  placementPlatform: string[]
}

export const BannerDetailsPlatform: FunctionComponent<Props> = ({ placementPlatform }) => {
  const messages = useDashMessages({
    emptyValue: 'bannersDomain.field.empty.value',
    PlatformLabel: 'bannersDomain.details.platform.platform',
  })

  // TODO: Remove this mapping once the values are modified in Retaiers-API
  const Platforms = placementPlatform
    .map(x => (x === PlacementPlatformEnum.Mobile ? 'MOBILE-WEB' : x))
    .map(x => (x === PlacementPlatformEnum.Web ? 'DESKTOP-WEB' : x))
    .join(', ')

  return (
    <MerchandisingFormSection titleId="bannersDomain.details.platform.title">
      <Text weight="semibold">{messages.PlatformLabel}</Text>
      <Text size="medium">{Platforms || messages.emptyValue}</Text>
    </MerchandisingFormSection>
  )
}
